import { memo } from 'react';
import { LeaveFamilyOnlyTemplate } from 'components/templates/LeaveFamilyOnlyTemplate';

type Props = {};

export const LeaveFamilyOnly = memo((_props: Props) => {
	return <LeaveFamilyOnlyTemplate />;
});
